import { axios } from '@Root/API'

export const tierFourRecords = id => {
	return axios.put(`data-pruning-tier/${id}`)
}
